var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewspaper(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.433,
    height: 21.876,
    viewBox: "0 0 23.433 21.876",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M22.746,21.76H17.529V17.687A.687.687,0,0,0,16.842,17H.687A.687.687,0,0,0,0,17.687V35.444a3.436,3.436,0,0,0,3.433,3.432H20a3.436,3.436,0,0,0,3.433-3.432v-13A.687.687,0,0,0,22.746,21.76ZM3.433,37.5a2.062,2.062,0,0,1-2.06-2.059V18.373H16.156c0,18.145-.009,17.136.016,17.395a3.422,3.422,0,0,0,.672,1.736ZM22.06,35.444A2.062,2.062,0,0,1,20,37.5h-.412a2.062,2.062,0,0,1-2.06-2.059V23.133H22.06Z",
    transform: "translate(0 -17)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M75.938,89H65.686a.686.686,0,0,0,0,1.373H75.938a.686.686,0,1,0,0-1.373Z",
    transform: "translate(-62.025 -85.705)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M75.938,153H65.686a.686.686,0,1,0,0,1.373H75.938a.686.686,0,1,0,0-1.373Z",
    transform: "translate(-62.025 -146.776)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M75.938,393H65.686a.687.687,0,0,0,0,1.373H75.938a.687.687,0,1,0,0-1.373Z",
    transform: "translate(-62.025 -375.792)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M182.812,217h-5.126a.687.687,0,0,0-.686.686v5.126a.687.687,0,0,0,.686.686h5.126a.687.687,0,0,0,.686-.686v-5.126A.687.687,0,0,0,182.812,217Zm-.686,5.126h-3.753v-3.753h3.753Z",
    transform: "translate(-168.899 -207.847)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.686,242.373h2.2a.686.686,0,1,0,0-1.373h-2.2a.686.686,0,1,0,0,1.373Z",
    transform: "translate(-62.025 -230.748)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M65.686,306.373h2.2a.686.686,0,1,0,0-1.373h-2.2a.686.686,0,1,0,0,1.373Z",
    transform: "translate(-62.025 -291.819)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewspaper);
export default __webpack_public_path__ + "static/media/newspaper.81402c234bea969cd31c91b6adaa8290.svg";
export { ForwardRef as ReactComponent };